import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import { Policy } from "@/enums/Policy";
import { differenceInMinutes } from "date-fns";
import AccessDeniedView from "@/views/error/AccessDeniedView.vue";
import SignedOutView from "@/views/base/SignedOutView.vue";
import LandingPageView from "@/views/base/LandingPage.vue";
import reportView from "@/views/base/ReportView.vue";
import publishReport from "@/views/base/PublishReportView.vue";
import MaintainNotificationView from "@/views/notifications/MaintainNotificationView.vue";
import AddNotificationView from "@/views/notifications/AddNotificationView.vue";
import authService from "@/services/application/authService";
import applicationService from "@/services/application/applicationService";
import AboutView from "@/views/base/AboutView.vue";
const AUTH_CHECK_THRESHOLD = 10;
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "landingPage",
            component: LandingPageView,
            meta: {
                requiresAuth: false,
                showReport: false
            },
        },
        {
            path: "/kpis",
            name: "KPIs",
            component: reportView,
            meta: {
                title: "KPIs",
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: true,
                pages: [
                    { displayName: "Dashboard", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Dashboard", showWeekFilter: false, showProductFilter: false },
                    { displayName: "AM Dashboard", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] AM Dashboard", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Sales", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Sales", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Availability", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Availability", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Blocking", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Blocking", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Complaints", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Complaints", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Delivery Partner Availability", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Delivery Partner Availability", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Shrinkage", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Shrinkage", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Stockloss", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Stockloss", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Wages", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Wages", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Controllable Costs", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Controllable Costs", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Audit", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Audit", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Data Dictionary", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "[Store] Data Dictionary", showProductFilter: false, showWeekFilter: false, showLocationFilter: false }
                ]
            },
        },
        {
            path: "/kpislastyear",
            name: "KPIsLastYear",
            component: reportView,
            meta: {
                title: "KPIsLastYear",
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: true,
                pages: [
                    { displayName: "Home", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Home", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Sales", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Sales", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Schedule", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Schedule", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Stockloss", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Stockloss", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Hours Utilisation", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Hours Utilisation", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Labour Turnover", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Labour Turnover", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Customer", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Customer", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Customer YTD", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Customer YTD", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Controllable Costs", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Controllable Costs", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Audit", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Audit", showWeekFilter: false, showProductFilter: false }
                ]
            },
        },
        {
            path: "/home",
            name: "Home",
            component: reportView,
            meta: {
                title: "Home",
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: false
            },
        },
        {
            path: "/about",
            name: "about",
            component: () => import("../views/base/AboutView.vue"),
            meta: {
                title: "About",
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: false
            },
        },
        {
            path: "/apps",
            name: "apps",
            component: () => import("../views/base/AboutView.vue"),
            meta: {
                title: "Applications",
                parentRouteName: "home",
                showReport: false
            }
        },
        {
            path: "/accessDenied",
            name: "accessDenied",
            component: AccessDeniedView,
            meta: {
                requiresAuth: true,
                showReport: false,
                title: "Access Denied"
            },
        },
        {
            path: "/signedout",
            name: "SignedOut",
            component: SignedOutView,
            meta: {
                requiresAuth: false,
                showReport: false,
                title: "Signed Out"
            },
        },
        {
            path: "/Sales",
            name: "Sales",
            component: reportView,
            meta: {
                title: "Sales And Performance",
                requiresAuth: true,
                parentRouteName: "home",
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: true,
                pages: [
                    { displayName: "Dashboard" },
                    { displayName: "Hourly Sales", showWeekFilter: false },
                    { displayName: "[Store] Hourly Sales", showWeekFilter: false },
                    { displayName: "SALES Landing Page", showWeekFilter: false },
                    { displayName: "[Store] SALES Landing Page", showWeekFilter: false },
                    { displayName: "UNITS Landing Page", showWeekFilter: false },
                    { displayName: "[Store] UNITS Landing Page", showWeekFilter: false },
                    { displayName: "TRANS Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] TRANS Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "BASK UNITS Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] BASK UNITS Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "BASK SPEND Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] BASK SPEND Landing Page", showWeekFilter: false, showProductFilter: false },
                    { displayName: "B2B Landing Page", showWeekFilter: false },
                    { displayName: "[Store] B2B Landing Page", showWeekFilter: false },
                    { displayName: "NEW Sales - Product", showWeekFilter: false },
                    { displayName: "NEW Sales - Location", showWeekFilter: false },
                    { displayName: "[Store] NEW Sales - Location", showWeekFilter: false },
                    { displayName: "NEW Sales - Hourly - Location", showWeekFilter: false },
                    { displayName: "[Store] NEW Sales - Hourly - Location", showWeekFilter: false },
                    { displayName: "NEW Sales - Hourly - Product", showWeekFilter: false },
                    { displayName: "NEW Sales - Trend", showWeekFilter: false },
                    { displayName: "NEW Sales - Thaw and Serve", showWeekFilter: false },
                    { displayName: "[Store] NEW Sales - Thaw and Serve", showWeekFilter: false },
                    { displayName: "NEW Units Sold - Location", showWeekFilter: false },
                    { displayName: "NEW Units Sold - Hourly - Location", showWeekFilter: false },
                    { displayName: "[Store] NEW Units Sold - Location", showWeekFilter: false },
                    { displayName: "NEW Units Sold - Product", showWeekFilter: false },
                    { displayName: "[Store] NEW Units Sold - Hourly - Location", showWeekFilter: false },
                    { displayName: "NEW Units Sold - Hourly - Product", showWeekFilter: false },
                    { displayName: "NEW Units Sold - Trend", showWeekFilter: false },
                    { displayName: "NEW Transactions - Location", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] NEW Transactions - Location", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Transactions - Hourly", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] NEW Transactions - Hourly", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Transactions - Trend", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Basket Units - Location", showWeekFilter: false },
                    { displayName: "[Store] NEW Basket Units - Location", showWeekFilter: false },
                    { displayName: "NEW Basket Units - Trend", showWeekFilter: false },
                    { displayName: "NEW Basket Spend - Location", showWeekFilter: false },
                    { displayName: "[Store] NEW Basket Spend - Location", showWeekFilter: false },
                    { displayName: "NEW Basket Spend - Trend", showWeekFilter: false },
                    { displayName: "NEW Transactions - Bonus Cards", showWeekFilter: false, showProductFilter: false },
                    { displayName: "B2B - Location", showWeekFilter: false },
                    { displayName: "[Store] B2B - Location", showWeekFilter: false },
                    { displayName: "B2B - Product", showWeekFilter: false },
                    { displayName: "[Store] B2B - Product", showWeekFilter: false },
                    { displayName: "B2B - Trend", showWeekFilter: false },
                    { displayName: "[Store] B2B - Trend", showWeekFilter: false },
                    { displayName: "NEW Incentive Campaign - Store", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] NEW Incentive Campaign - Store", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Incentive Campaign - Store Regional League", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] NEW Incentive Campaign - Store Regional League", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Incentive Campaign - Area", showWeekFilter: false, showProductFilter: false },
                    { displayName: "NEW Incentive Campaign - Region", showWeekFilter: false, showProductFilter: false }
                ]
            },
        },
        {
            path: "/Inventory",
            name: "Inventory",
            component: reportView,
            meta: {
                title: "Inventory Performance",
                requiresAuth: true,
                parentRouteName: "home",
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: true,
                pages: [
                    { displayName: "Landing Page", showWeekFilter: false },
                    { displayName: "[Store] Landing Page", showWeekFilter: false },
                    { displayName: "Landing DPA", showWeekFilter: false },
                    { displayName: "[Store] Landing DPA", showWeekFilter: false },
                    { displayName: "Landing TTG", showWeekFilter: false },
                    { displayName: "[Store] Landing TTG", showWeekFilter: false },
                    { displayName: "Landing BSM", showWeekFilter: false },
                    { displayName: "[Store] Landing BSM", showWeekFilter: false },
                    { displayName: "Landing SPWI", showWeekFilter: false },
                    { displayName: "[Store] Landing SPWI", showWeekFilter: false },
                    { displayName: "OCA Product", showWeekFilter: false },
                    { displayName: "[Store] OCA Product", showWeekFilter: false },
                    { displayName: "OCA Product Breakdown", showWeekFilter: false },
                    { displayName: "[Store] OCA Product Breakdown", showWeekFilter: false },
                    { displayName: "OCA Short Reasons", showWeekFilter: false },
                    { displayName: "[Store] OCA Short Reasons", showWeekFilter: false },
                    { displayName: "OCA Short Reason Breakdown", showWeekFilter: false },
                    { displayName: "[Store] OCA Short Reason Breakdown", showWeekFilter: false },
                    { displayName: "OCA % Trend Date", showWeekFilter: false },
                    { displayName: "[Store] OCA % Trend Date", showWeekFilter: false },
                    { displayName: "OCA % Trend Loc", showWeekFilter: false },
                    { displayName: "[Store] OCA % Trend Loc", showWeekFilter: false },
                    { displayName: "OCA % Trend Plu", showWeekFilter: false },
                    { displayName: "[Store] OCA % Trend Plu", showWeekFilter: false },
                    { displayName: "OCA Units Trend Date", showWeekFilter: false },
                    { displayName: "[Store] OCA Units Trend Date", showWeekFilter: false },
                    { displayName: "OCA Units Trend Loc", showWeekFilter: false },
                    { displayName: "[Store] OCA Units Trend Loc", showWeekFilter: false },
                    { displayName: "OCA Units Trend Plu", showWeekFilter: false },
                    { displayName: "[Store] OCA Units Trend Plu", showWeekFilter: false },
                    { displayName: "DPA Short Reason", showWeekFilter: false },
                    { displayName: "[Store] DPA Short Reason", showWeekFilter: false },
                    { displayName: "DPA Short Reason Breakdown", showWeekFilter: false },
                    { displayName: "[Store] DPA Short Reason Breakdown", showWeekFilter: false },
                    { displayName: "DPA Short Timeline", showWeekFilter: false },
                    { displayName: "[Store] DPA Short Timeline", showWeekFilter: false },
                    { displayName: "DPA % Trend Date", showWeekFilter: false },
                    { displayName: "[Store] DPA % Trend Date", showWeekFilter: false },
                    { displayName: "DPA % Trend Loc", showWeekFilter: false },
                    { displayName: "[Store] DPA % Trend Loc", showWeekFilter: false },
                    { displayName: "DPA % Trend Plu", showWeekFilter: false },
                    { displayName: "[Store] DPA % Trend Plu", showWeekFilter: false },
                    { displayName: "DPA % Trend Partner", showWeekFilter: false },
                    { displayName: "[Store] DPA % Trend Partner", showWeekFilter: false },
                    { displayName: "TTG Breakdown", showWeekFilter: false },
                    { displayName: "[Store] TTG Breakdown", showWeekFilter: false },
                    { displayName: "BSM Breakdown", showWeekFilter: false },
                    { displayName: "[Store] BSM Breakdown", showWeekFilter: false },
                    { displayName: "SPWI Location", showWeekFilter: false },
                    { displayName: "[Store] SPWI Location", showWeekFilter: false },
                    { displayName: "SPWI Product", showWeekFilter: false },
                    { displayName: "[Store] SPWI Product", showWeekFilter: false },
                    { displayName: "SPWI Orders", showWeekFilter: false },
                    { displayName: "[Store] SPWI Orders", showWeekFilter: false },
                    { displayName: "Depot Delivery Receipt", showWeekFilter: false },
                    { displayName: "[Store] Depot Delivery Receipt", showWeekFilter: false },
                    { displayName: "Depot Delivery Receipt Container", showWeekFilter: false },
                    { displayName: "[Store] Depot Delivery Receipt Container", showWeekFilter: false },
                    { displayName: "Depot Delivery Receipt Product", showWeekFilter: false },
                    { displayName: "[Store] Depot Delivery Receipt Product", showWeekFilter: false },
                ]
            }
        },
        {
            path: "/Costs",
            name: "Costs",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Costs",
                pages: [
                    { displayName: "Landing Page - Shrinkage", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Shrinkage", showWeekFilter: false },
                    { displayName: "Landing Page - Shrinkage Perc", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Shrinkage Perc", showWeekFilter: false },
                    { displayName: "Landing Page - Markdown", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Markdown", showWeekFilter: false },
                    { displayName: "Landing Page - Stockloss", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Stockloss", showWeekFilter: false },
                    { displayName: "Landing Page - Wages", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Wages", showWeekFilter: false },
                    { displayName: "Landing Page - Absence", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - Absence", showWeekFilter: false },
                    { displayName: "Landing Page - LTO", showWeekFilter: false },
                    { displayName: "[Store] Landing Page - LTO", showWeekFilter: false },
                    { displayName: "Shrinkage - Location", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage - Location", showWeekFilter: false },
                    { displayName: "Shrinkage - Product", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage - Product", showWeekFilter: false },
                    { displayName: "Shrinkage - Reason", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage - Reason", showWeekFilter: false },
                    { displayName: "Shrinkage - Reason Detail", showWeekFilter: false },
                    { displayName: "Shrinkage - Trend", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage - Trend", showWeekFilter: false },
                    { displayName: "Shrinkage - Thaw and Serve", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage - Thaw and Serve", showWeekFilter: false },
                    { displayName: "Markdown - Overview", showWeekFilter: false },
                    { displayName: "Markdown - Location", showWeekFilter: false },
                    { displayName: "Markdown - Product", showWeekFilter: false },
                    { displayName: "[Store] Markdown - Product", showWeekFilter: false },
                    { displayName: "Markdown - Trend", showWeekFilter: false },
                    { displayName: "[Store] Markdown - Trend", showWeekFilter: false },
                    { displayName: "Stockloss - Location", showWeekFilter: false },
                    { displayName: "Stockloss - Product", showWeekFilter: false },
                    { displayName: "[Store] Stockloss - Product", showWeekFilter: false },
                    { displayName: "Stockloss - Reason", showWeekFilter: false },
                    { displayName: "[Store] Stockloss - Reason", showWeekFilter: false },
                    { displayName: "Stockloss - Trend", showWeekFilter: false },
                    { displayName: "[Store] Stockloss - Trend", showWeekFilter: false },
                    { displayName: "Hours - Location", showWeekFilter: false },
                    { displayName: "Hours - Trend", showWeekFilter: false },
                    { displayName: "[Store] Hours - Trend", showWeekFilter: false },
                    { displayName: "Absence - Location", showWeekFilter: false },
                    { displayName: "Absence - Trend", showWeekFilter: false },
                    { displayName: "LTO - Location", showWeekFilter: false },
                    { displayName: "LTO - Trend", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Location", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage Perc - Location", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Product", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage Perc - Product", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Reason", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage Perc - Reason", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Reason Detail", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Trend", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage Perc - Trend", showWeekFilter: false },
                    { displayName: "Shrinkage Perc - Thaw and Serve", showWeekFilter: false },
                    { displayName: "[Store] Shrinkage Perc - Thaw and Serve", showWeekFilter: false },
                ]
            }
        },
        {
            path: "/People",
            name: "People",
            component: reportView,
            meta: {
                title: "People",
                requiresAuth: true,
                parentRouteName: "home",
                requiredPolicy: [Policy.BASIC_ACCESS],
                showReport: true,
                pages: [
                    { displayName: "Dashboard", showProductFilter: false },
                    { displayName: "[Store] Dashboard", showProductFilter: false },
                    { displayName: "Absence", showProductFilter: false },
                    { displayName: "[Store] Absence", showProductFilter: false },
                    { displayName: "STS", showProductFilter: false },
                    { displayName: "[Store] STS", showProductFilter: false },
                    { displayName: "LTS", showProductFilter: false },
                    { displayName: "[Store] LTS", showProductFilter: false },
                    { displayName: "AWOL", showProductFilter: false },
                    { displayName: "[Store] AWOL", showProductFilter: false },
                    { displayName: "LTO", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] LTO", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Working", showProductFilter: false },
                    { displayName: "Working Data", showProductFilter: false },
                    { displayName: "[Store] Working", showProductFilter: false },
                    { displayName: "Leavers", showProductFilter: false },
                    { displayName: "Leavers Data", showProductFilter: false },
                    { displayName: "[Store] Leavers", showProductFilter: false },
                    { displayName: "New Starter", showProductFilter: false, showWeekFilter: false },
                    { displayName: "New Starter Data", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] New Starter", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Seasonal", showProductFilter: false },
                    { displayName: "Seasonal Data", showProductFilter: false },
                    { displayName: "[Store] Seasonal", showProductFilter: false },
                    { displayName: "Colleague Absences", showLocationFilter: false, showProductFilter: false, showWeekFilter: false },
                    { displayName: "Colleague Absence Calendar", showLocationFilter: false, showProductFilter: false, showWeekFilter: false },
                    { displayName: "Pro Tem Payments", showProductFilter: false },
                    { displayName: "[Store] Pro Tem Payments", showProductFilter: false },
                    { displayName: "Travel Payments", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Travel Payments", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Travel Payments Data", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Travel Payment Calendar", showProductFilter: false, showWeekFilter: false },
                    { displayName: "> 48 Hours", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] > 48 Hours", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Future > 48 Hours", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Future > 48 Hours", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Future > 48 Hours Data", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Timesheet Hours", showProductFilter: false },
                    { displayName: "[Store] Timesheet Hours", showProductFilter: false },
                    { displayName: "Timesheet Data", showProductFilter: false },
                    { displayName: "Standard vs Worked Hours", showProductFilter: false },
                    { displayName: "[Store] Standard vs Worked Hours", showProductFilter: false },
                    { displayName: "Compassionate", showProductFilter: false },
                    { displayName: "Compassionate Data", showProductFilter: false },
                    { displayName: "[Store] Compassionate", showProductFilter: false },
                    { displayName: "Suspensions", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Suspensions", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Investigations", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Investigations", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Disciplinaries", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Disciplinaries", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Disciplinaries Data", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Investigations", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Investigations Data", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Investigations", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Holiday Utilisation", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Holiday Utilisation", showProductFilter: false, showWeekFilter: false },
                    { displayName: "No Induction", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] No Induction", showProductFilter: false, showWeekFilter: false },
                    { displayName: "No Manager Skill", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] No Manager Skill", showProductFilter: false, showWeekFilter: false },
                    { displayName: "No HDD Skill", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] No HDD Skill", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Legal Refresher", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Legal Refresher", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Role Sign Off", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Role Sign Off", showProductFilter: false, showWeekFilter: false },
                    { displayName: "Skills Matrix", showProductFilter: false },
                    { displayName: "Holiday Absence", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Holiday Absence", showProductFilter: false, showWeekFilter: false },
                ]
            },
        },
        {
            path: "/Fleet",
            name: "Fleet",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Fleet",
                pages: [
                    { displayName: "New Dashboard", showProductFilter: false },
                    { displayName: "[Store] New Dashboard", showProductFilter: false },
                    { displayName: "Fleet Distribution", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Store] Fleet Distribution", showProductFilter: false, showWeekFilter: false },
                    { displayName: "DMC", showProductFilter: false },
                    { displayName: "[Store] DMC", showProductFilter: false },
                    { displayName: "LIGHTFOOT", showProductFilter: false },
                    { displayName: "[Store] LIGHTFOOT", showProductFilter: false }
                ]
            }
        },
        {
            path: "/ScheduleTemplate",
            name: "ScheduleTemplate",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "ScheduleTemplate",
                pages: [
                    { displayName: "Template", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Template", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Stores Without Templates", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Demand Forecast", showWeekFilter: false, showProductFilter: false },
                    { displayName: "Validation Errors", showWeekFilter: false, showProductFilter: false },
                    { displayName: "[Store] Validation Errors", showWeekFilter: false, showProductFilter: false }
                ]
            }
        },
        {
            path: "/RetailInsight",
            name: "RetailInsight",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "RetailInsight",
                pages: [
                    { displayName: "RI Summary", showWeekFilter: false },
                    { displayName: "[Store] RI Summary", showWeekFilter: false },
                    { displayName: "Next 14 Days Workload", showWeekFilter: false },
                    { displayName: "[Store] Next 14 Days Workload", showWeekFilter: false },
                    { displayName: "Drill - Markdown Compliance", showWeekFilter: false },
                    { displayName: "[Store] Drill - Markdown Compliance", showWeekFilter: false },
                    { displayName: "Drill - EOD Checks", showWeekFilter: false },
                    { displayName: "[Store] Drill - EOD Checks", showWeekFilter: false },
                    { displayName: "Drill - Waste on RI", showWeekFilter: false },
                    { displayName: "[Store] Drill - Waste on RI", showWeekFilter: false },
                    { displayName: "Drill - OOD Waste", showWeekFilter: false },
                    { displayName: "[Store] Drill - OOD Waste", showWeekFilter: false },
                    { displayName: "Drill - RTC", showWeekFilter: false },
                    { displayName: "[Store] Drill - RTC", showWeekFilter: false }
                ]
            }
        },
        {
            path: "/Atlas",
            name: "Atlas",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Atlas",
                pages: [
                    { displayName: "Landing Page", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Summary", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Top N Details", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Summary Test Page", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Top N Details Testing Page", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Open Incidents", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Historic Incident Review", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Details", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Details (Open Incidents Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Incident Details (Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Change Summary", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Open Changes", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Historic Change Review", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Change Details", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Change Details (Open Changes Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Change Details (Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Request Summary", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Open Requests", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Historic Request Review", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Request Details", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Request Details (Open Requests Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Request Details (Drillthrough)", showProductFilter: false, showWeekFilter: false, showLocationFilter: false },
                    { displayName: "Filter Menu", showProductFilter: false, showWeekFilter: false, showLocationFilter: false }
                ]
            }
        },
        {
            path: "/Buying",
            name: "Buying",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Buying",
                pages: [
                    { displayName: "[Daily Summary] Summary", showWeekFilter: false },
                    { displayName: "[Daily Summary] Weekly Comparison", showWeekFilter: false },
                    { displayName: "[Range Review] Sales", showWeekFilter: false },
                    { displayName: "[Range Review] Units Sold", showWeekFilter: false },
                    { displayName: "[Range Review] PBLS", showWeekFilter: false },
                    { displayName: "[Range Review] Shrinkage", showWeekFilter: false },
                    { displayName: "[Weekly Margin] Transactions", showProductFilter: false },
                    { displayName: "[Cycle Daily Sales] Sales", showWeekFilter: false },
                    { displayName: "[Cycle Daily Sales] Table", showWeekFilter: false },
                    { displayName: "[Slideshow] Sales", showWeekFilter: false },
                    { displayName: "[Slideshow] Sales [Like-for-like]", showWeekFilter: false },
                    { displayName: "[Slideshow] Units Sold", showWeekFilter: false },
                    { displayName: "[Slideshow] Clean Units Sold", showWeekFilter: false },
                    { displayName: "[Slideshow] Transactions", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Slideshow] Transactions [Like-for-like]", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Slideshow] Average Sell Price", showWeekFilter: false },
                    { displayName: "[Slideshow] Average Cost Price", showWeekFilter: false },
                    { displayName: "[Slideshow] PBLS", showWeekFilter: false },
                    { displayName: "[Slideshow] PBLS %", showWeekFilter: false },
                    { displayName: "[Slideshow] Shrinkage", showWeekFilter: false },
                    { displayName: "[Slideshow] Shrinkage %", showWeekFilter: false },
                    { displayName: "[Slideshow] Supply Service Level", showWeekFilter: false }
                ]
            }
        },
        {
            path: "/Buying",
            name: "Buying",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Buying",
                pages: [
                    { displayName: "[Daily Summary] Summary", showWeekFilter: false },
                    { displayName: "[Daily Summary] Weekly Comparison", showWeekFilter: false },
                    { displayName: "[Range Review] Sales", showWeekFilter: false },
                    { displayName: "[Range Review] Units Sold", showWeekFilter: false },
                    { displayName: "[Range Review] PBLS", showWeekFilter: false },
                    { displayName: "[Range Review] Shrinkage", showWeekFilter: false },
                    { displayName: "[Weekly Margin] Transactions", showProductFilter: false },
                    { displayName: "[Cycle Daily Sales] Sales", showWeekFilter: false },
                    { displayName: "[Cycle Daily Sales] Table", showWeekFilter: false },
                    { displayName: "[Slideshow] Sales", showWeekFilter: false },
                    { displayName: "[Slideshow] Sales [Like-for-like]", showWeekFilter: false },
                    { displayName: "[Slideshow] Units Sold", showWeekFilter: false },
                    { displayName: "[Slideshow] Clean Units Sold", showWeekFilter: false },
                    { displayName: "[Slideshow] Transactions", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Slideshow] Transactions [Like-for-like]", showProductFilter: false, showWeekFilter: false },
                    { displayName: "[Slideshow] Average Sell Price", showWeekFilter: false },
                    { displayName: "[Slideshow] Average Cost Price", showWeekFilter: false },
                    { displayName: "[Slideshow] PBLS", showWeekFilter: false },
                    { displayName: "[Slideshow] PBLS %", showWeekFilter: false },
                    { displayName: "[Slideshow] Shrinkage", showWeekFilter: false },
                    { displayName: "[Slideshow] Shrinkage %", showWeekFilter: false },
                    { displayName: "[Slideshow] Supply Service Level", showWeekFilter: false }
                ]
            }
        },
        {
            path: "/CustomReport",
            name: "CustomReport",
            component: reportView,
            meta: {
                requiresAuth: true,
                requiredPolicy: [Policy.BASIC_ACCESS],
                parentRouteName: "home",
                showReport: true,
                title: "Custom Report"
            }
        },
        {
            path: "/publish",
            name: "publish",
            component: publishReport,
            meta: {
                title: "Publish Report",
                requiresAuth: true,
                requiredPolicy: [Policy.SYS_ADMIN],
                showReport: false
            },
        },
        {
            path: "/admin",
            name: "Admin",
            component: AboutView,
            meta: {
                title: "Admin Menu",
                requiresAuth: true,
                requiredPolicy: [Policy.SYS_ADMIN],
                showReport: false
            }
        },
        {
            path: "/admin/notification",
            name: "Maintain Notifications",
            component: MaintainNotificationView,
            meta: {
                title: "Maintain Notifications",
                requiresAuth: true,
                requiredPolicy: [Policy.SYS_ADMIN],
                showReport: false
            }
        },
        {
            path: "/admin/notification/add",
            name: "Add Notification",
            component: AddNotificationView,
            meta: {
                title: "Add Notification",
                requiresAuth: true,
                requiredPolicy: [Policy.SYS_ADMIN],
                showReport: false
            }
        }
    ],
});
router.beforeEach(async (targetRoute) => {
    document.title = `Viewpoint | ${targetRoute.meta.title ? targetRoute.meta.title : ""}`;
    const authStore = useAuthStore();
    const authSvc = new authService();
    const requiresAuth = targetRoute.matched.some((route) => route.meta.requiresAuth);
    function needsAuthCheck() {
        const authCheck = differenceInMinutes(new Date(), authStore.lastAuthenticated) >
            AUTH_CHECK_THRESHOLD;
        return authCheck;
    }
    function authenticated() {
        return authStore.user?.isAuthenticated ?? false;
    }
    if (requiresAuth ?? true) {
        if (!authenticated() || needsAuthCheck()) {
            await authSvc.getUser();
            if (!authenticated()) {
                authSvc.login(targetRoute.fullPath);
                return false;
            }
        }
        if (!authStore.user.meetsPolicies((targetRoute.meta.requiredPolicy ?? []))) {
            {
                router.push("AccessDenied");
            }
        }
    }
});
router.afterEach((fromRoute, targetRoute, failure) => {
    const appService = new applicationService();
    appService.updateBreadcrumbs(router);
});
export default router;
